import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "ui-card__title" }, " Business details "),
    /*#__PURE__*/_createElementVNode("p", { class: "ui-card__subtitle" }, " Enter your company's business details below ")
  ])
], -1)
const _hoisted_2 = { class: "flex gap-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_4 = { class: "flex gap-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "p-2 rounded-md bg-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, [
    /*#__PURE__*/_createTextVNode(" Your legal business name and registration number must be an exact match with your official tax filing paperwork. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Failure to do so may result in your registration being rejected. ")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "ui-card__title" }, " Business address "),
    /*#__PURE__*/_createElementVNode("p", { class: "ui-card__subtitle" }, " Tell us where the business above is located ")
  ])
], -1)
const _hoisted_7 = { class: "flex gap-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "ui-card__title" }, " Point of contact "),
    /*#__PURE__*/_createElementVNode("p", { class: "ui-card__subtitle" }, " Enter a main point of contact for the business ")
  ])
], -1)
const _hoisted_9 = { class: "flex gap-4" }
const _hoisted_10 = { class: "flex gap-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "ui-card__title" }, " Messaging details "),
    /*#__PURE__*/_createElementVNode("p", { class: "ui-card__subtitle" }, " Be sure to provide detailed and accurate information. Vague or short responses can result in your registration being rejected. ")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "flex mt-4 flex-col" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-sm" }, " How will your business use text messaging day to day? "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-light text-sm" }, " Describe the most common scenarios in which you and your employees will communicate with US phone numbers via messaging. ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-sm" }, " How do you collect consent to send text messages? "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-light text-sm" }, " Details around how a consumer opts-in to their campaign, therefore giving consent to receive their messages. If multiple opt-in methods can be used for the same campaign, they must all be listed. ")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-sm" }, " What specific text messages will you typically send? "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-light text-sm" }, " Provide at least two examples (more is better) of a text message you'll typically send to US phone numbers that matches the scenarios you've listed above. If you send links, be sure to include them. ")
], -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, " Summary of fees "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, " The process and its associated fees are mandated by US carriers. As such, Thatch passes all fees directly to US carriers reivew partners. "),
  /*#__PURE__*/_createElementVNode("div", { class: "p-2 flex-col rounded-md border border-solid border-blue-500" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "Carrier review and setup feed"),
      /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "$19 one-time")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "Messaging fee"),
      /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "$1.50/month")
    ])
  ])
], -1)
const _hoisted_17 = {
  key: 1,
  class: "flex justify-end"
}

import {
	UiForm,
	UiInput,
	UiLine,
	UiButton,
	useForm,
	SelectOption,
	UiSelect,
	UiCheckbox,
	SvgIcon
} from '@/ui-kit';
import { phoneNumber, uuid } from '@/utils';
import {
	required,
	minLength,
	url,
	email,
	maxLength
} from '@vuelidate/validators';
import { countries, states } from './contries-and-states';
import { computed, onBeforeMount } from 'vue';
import MessageSample from '../components/MessageSample.vue';
import { useSmsTrustState, Trust } from '../state';
import { useToast } from 'vue-toastification';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrustForm',
  props: {
    state: null
  },
  setup(__props: any) {

const props = __props as {
	state?: Trust;
};



const isSubmitted = computed(() => {
	return (
		props.state?.data &&
		props.state?.data?.evaluation_status !==
			'noncompliant'
	);
});

const businessTypeOptions: SelectOption[] = [
	{
		title: 'Partnership',
		value: 'Partnership'
	},
	{
		title: 'Limited Liability Corporation',
		value: 'Limited Liability Corporation'
	},
	{
		title: 'Co-operative',
		value: 'Co-operative'
	},
	{
		title: 'Non-profit Corporation',
		value: 'Non-profit Corporation'
	},
	{
		title: 'Corporation',
		value: 'Corporation'
	}
];

const businessRegistrationIdentifierOptions: SelectOption[] =
	[
		'EIN',
		'DUNS',
		'CBN',
		'CN',
		'ACN',
		'CIN',
		'VAT',
		'VATRN',
		'RN',
		'Other'
	].map((item) => ({ title: item, value: item }));

const businessIndustryOptions: SelectOption[] = [
	'AUTOMOTIVE',
	'AGRICULTURE',
	'BANKING',
	'CONSTRUCTION',
	'CONSUMER',
	'EDUCATION',
	'ENGINEERING',
	'ENERGY',
	'OIL_AND_GAS',
	'FAST_MOVING_CONSUMER_GOODS',
	'FINANCIAL',
	'FINTECH',
	'FOOD_AND_BEVERAGE',
	'GOVERNMENT',
	'HEALTHCARE',
	'HOSPITALITY',
	'INSURANCE',
	'LEGAL',
	'MANUFACTURING',
	'MEDIA',
	'ONLINE',
	'PROFESSIONAL_SERVICES',
	'RAW_MATERIALS',
	'REAL_ESTATE',
	'RELIGION',
	'RETAIL',
	'JEWELRY',
	'TECHNOLOGY',
	'TELECOMMUNICATIONS',
	'TRANSPORTATION',
	'TRAVEL',
	'ELECTRONICS',
	'NOT_FOR_PROFIT'
].map((item) => ({
	title: `${item.charAt(0)}${item
		.slice(1)
		.toLowerCase()}`.replace(/_/gi, ' '),
	value: item
}));

const businessRegionsOfOperationOptions: SelectOption[] = [
	{
		title: 'Africa',
		value: 'AFRICA'
	},
	{
		title: 'Asia',
		value: 'ASIA'
	},
	{
		title: 'Europe',
		value: 'EUROPE'
	},
	{
		title: 'Latin America',
		value: 'LATIN_AMERICA'
	},
	{
		title: 'USA and Canada',
		value: 'USA_AND_CANADA'
	}
];

function randomId() {
	return uuid(12);
}

const {
	formData,
	onSubmit,
	onError,
	loading,
	setFieldErrors,
	fillFormData,
	validator
} = useForm(
	{
		business_name: '',
		business_type: '',
		company_type: 'private',
		business_registration_identifier: '',
		business_registration_number: '',
		website_url: '',
		business_regions_of_operation: '',
		business_industry: '',
		street: '',
		city: '',
		region: '',
		postal_code: '',
		iso_country: countries[0].value,
		street_secondary: '',
		first_name: '',
		last_name: '',
		email: '',
		job_position: '',
		business_title: '',
		phone_number: '',
		has_embedded_links: false,
		has_embedded_phone: false,
		description: '',
		message_flow: '',
		message_samples: [
			{
				value: '',
				id: randomId()
			},
			{
				value: '',
				id: randomId()
			}
		]
	},
	{
		business_name: {
			required,
			minLength: minLength(2)
		},
		business_type: {
			required
		},
		business_registration_identifier: {
			required
		},
		business_registration_number: {
			required,
			minLength: minLength(2)
		},
		website_url: {
			required,
			url
		},
		business_regions_of_operation: {
			required
		},
		business_industry: {
			required
		},
		street: {
			required,
			minLength: minLength(2)
		},
		city: {
			required,
			minLength: minLength(2)
		},
		region: {
			required,
			minLength: minLength(2)
		},
		postal_code: {
			required
		},
		iso_country: {
			required
		},
		first_name: {
			required,
			minLength: minLength(2)
		},
		last_name: {
			required,
			minLength: minLength(2)
		},
		phone_number: {
			required,
			phoneNumber
		},
		email: {
			required,
			email
		},
		job_position: {
			required,
			minLength: minLength(2)
		},
		business_title: {
			required,
			minLength: minLength(2)
		},
		description: {
			required,
			minLength: minLength(40),
			maxLength: maxLength(4096)
		},
		message_flow: {
			required,
			minLength: minLength(40),
			maxLength: maxLength(2048)
		},
		message_samples: {
			required,
			minLength: minLength(2),
			maxLength: maxLength(5)
		}
	}
);

const jobPositionOptions: SelectOption[] = [
	'Director',
	'GM',
	'VP',
	'CEO',
	'CFO',
	'General Counsel',
	'Other'
].map((item) => ({
	title: item,
	value: item
}));

const stateOptions = computed(() => {
	return (
		states[
			formData.iso_country as keyof typeof states
		] || []
	);
});

function removeItem(id: string) {
	formData.message_samples =
		formData.message_samples.filter(
			(item) => item.id !== id
		);
}

const smsTrust = useSmsTrustState();

onBeforeMount(() => {
	if (!props.state) {
		return;
	}

	if (
		smsTrust.isNonComplient &&
		props.state.data.evaluation_results.length
	) {
		setFieldErrors(
			evaliationResultsToBackendErrors(
				props.state.data.evaluation_results
			)
		);
		validator.value?.$touch();
	}

	const {
		type,
		websiteUrl,
		businessName,
		businessType,
		businessIdentity,
		businessIndustry,
		businessRegistrationNumber,
		businessRegionsOfOperation,
		businessRegistrationIdentifier
	} = props.state.data.businessInfo;

	const {
		customer_name,
		iso_country,
		postal_code,
		city,
		street,
		street_secondary,
		region
	} = props.state.data.businessAddress;

	const {
		email,
		last_name,
		first_name,
		job_position,
		phone_number,
		business_title
	} = props.state.data.pointOfContact;

	const { messageSamples, description, messageFlow } =
		props.state.campaign || {
			messageFlow: '',
			description: '',
			messageSamples: ['', '']
		};

	fillFormData({
		business_name: businessName,
		business_type: businessType,
		company_type: 'private',
		business_registration_identifier:
			businessRegistrationIdentifier,
		business_registration_number:
			businessRegistrationNumber,
		website_url: websiteUrl,
		business_regions_of_operation:
			businessRegionsOfOperation,
		business_industry: businessIndustry,
		street,
		city,
		region,
		postal_code,
		iso_country,
		street_secondary,
		first_name,
		last_name,
		email,
		job_position,
		business_title,
		phone_number,
		has_embedded_links: false,
		has_embedded_phone: false,
		description,
		message_flow: messageFlow,
		message_samples: messageSamples.map((value) => ({
			value,
			id: randomId()
		}))
	});
});

function evaliationResultsToBackendErrors(
	results: any[]
): Record<string, [string]> {
	return results
		.flatMap((items: any) =>
			items.fields.filter((item: any) => !item.passed)
		)
		.map((item: any) => [
			item.object_field,
			[item.failure_reason]
		])
		.reduce(
			(acc, [key, value]) => ({
				...acc,
				[key]: value
			}),
			{}
		);
}

const toast = useToast();

const submit = onSubmit(async (data) => {
	try {
		await smsTrust.submitTrust({
			business_information: {
				business_name: data.business_name,
				business_type: data.business_type,
				business_registration_identifier:
					data.business_registration_identifier,
				business_registration_number:
					data.business_registration_number,
				business_industry: data.business_industry,
				website_url: data.website_url,
				business_regions_of_operation:
					data.business_regions_of_operation,
				company_type: data.company_type
			},
			authorized_representative_1: {
				first_name: data.first_name,
				last_name: data.last_name,
				phone_number: data.phone_number.replace(
					/[ -]/g,
					''
				),
				email: data.email,
				job_position: data.job_position,
				business_title: data.business_title
			},
			address: {
				street: data.street,
				city: data.city,
				region: data.region,
				postal_code: data.postal_code,
				iso_country: data.iso_country
			},
			messaging_details: {
				description: data.description,
				message_flow: data.message_flow,
				message_samples: data.message_samples.map(
					(item) => item.value
				),
				has_embedded_links: data.has_embedded_links,
				has_embedded_phone: data.has_embedded_phone
			}
		});
		toast.success(
			'SMS Trust verification successfully submitted'
		);
	} catch (err) {
	} finally {
		await smsTrust.reLoadTrust();
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UiForm), {
    class: "flex flex-col gap-2 max-w-screen-md",
    onSubmit: _unref(submit)
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_unref(UiInput), {
        modelValue: _unref(formData).business_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).business_name) = $event)),
        name: "business_name",
        label: "Legal business name",
        placeholder: "Your Co."
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(UiSelect), {
          disabled: _unref(loading) || _unref(isSubmitted),
          modelValue: _unref(formData).business_type,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).business_type) = $event)),
          options: businessTypeOptions,
          name: "business_type",
          label: "Business Type"
        }, null, 8, ["disabled", "modelValue"]),
        _hoisted_3
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(UiSelect), {
          disabled: _unref(loading) || _unref(isSubmitted),
          options: 
					_unref(businessRegistrationIdentifierOptions)
				,
          modelValue: 
					_unref(formData).business_registration_identifier
				,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((
					_unref(formData).business_registration_identifier
				) = $event)),
          name: "business_registration_identifier",
          label: "Business registration ID type"
        }, null, 8, ["disabled", "options", "modelValue"]),
        _createVNode(_unref(UiInput), {
          disabled: _unref(loading) || _unref(isSubmitted),
          modelValue: 
					_unref(formData).business_registration_number
				,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((
					_unref(formData).business_registration_number
				) = $event)),
          name: "business_registration_number",
          label: "Business registration number"
        }, null, 8, ["disabled", "modelValue"])
      ]),
      _hoisted_5,
      _createVNode(_unref(UiSelect), {
        disabled: _unref(loading) || _unref(isSubmitted),
        label: "Industry",
        options: _unref(businessIndustryOptions),
        modelValue: _unref(formData).business_industry,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).business_industry) = $event)),
        name: "business_industry"
      }, null, 8, ["disabled", "options", "modelValue"]),
      _createVNode(_unref(UiInput), {
        disabled: _unref(loading) || _unref(isSubmitted),
        label: "Website, business listing, or other online presence",
        modelValue: _unref(formData).website_url,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).website_url) = $event)),
        name: "website_url"
      }, null, 8, ["disabled", "modelValue"]),
      _createVNode(_unref(UiSelect), {
        disabled: _unref(loading) || _unref(isSubmitted),
        options: businessRegionsOfOperationOptions,
        label: "Regions of operation",
        modelValue: _unref(formData).business_regions_of_operation,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formData).business_regions_of_operation) = $event)),
        name: "business_regions_of_operation"
      }, null, 8, ["disabled", "modelValue"]),
      _createVNode(_unref(UiLine)),
      _hoisted_6,
      _createVNode(_unref(UiSelect), {
        disabled: _unref(loading) || _unref(isSubmitted),
        label: "Country",
        options: _unref(countries),
        modelValue: _unref(formData).iso_country,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formData).iso_country) = $event)),
        name: "iso_country"
      }, null, 8, ["disabled", "options", "modelValue"]),
      _createVNode(_unref(UiInput), {
        disabled: _unref(loading) || _unref(isSubmitted),
        label: "Address line 1",
        modelValue: _unref(formData).street,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formData).street) = $event)),
        name: "street"
      }, null, 8, ["disabled", "modelValue"]),
      _createVNode(_unref(UiInput), {
        disabled: _unref(loading) || _unref(isSubmitted),
        label: "Address line 2",
        modelValue: _unref(formData).street_secondary,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(formData).street_secondary) = $event)),
        name: "street_secondary"
      }, null, 8, ["disabled", "modelValue"]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(UiInput), {
          disabled: _unref(loading) || _unref(isSubmitted),
          label: "City",
          modelValue: _unref(formData).city,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(formData).city) = $event)),
          name: "city"
        }, null, 8, ["disabled", "modelValue"]),
        _createVNode(_unref(UiSelect), {
          disabled: _unref(loading) || _unref(isSubmitted),
          name: "region",
          modelValue: _unref(formData).region,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(formData).region) = $event)),
          label: "State / Province",
          options: _unref(stateOptions)
        }, null, 8, ["disabled", "modelValue", "options"]),
        _createVNode(_unref(UiInput), {
          disabled: _unref(loading) || _unref(isSubmitted),
          label: "Postal code",
          modelValue: _unref(formData).postal_code,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(formData).postal_code) = $event)),
          name: "postal_code"
        }, null, 8, ["disabled", "modelValue"])
      ]),
      _createVNode(_unref(UiLine)),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(UiInput), {
          disabled: _unref(loading) || _unref(isSubmitted),
          label: "First name",
          name: "first_name",
          modelValue: _unref(formData).first_name,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(formData).first_name) = $event))
        }, null, 8, ["disabled", "modelValue"]),
        _createVNode(_unref(UiInput), {
          disabled: _unref(loading) || _unref(isSubmitted),
          label: "Last name",
          name: "last_name",
          modelValue: _unref(formData).last_name,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(formData).last_name) = $event))
        }, null, 8, ["disabled", "modelValue"])
      ]),
      _createVNode(_unref(UiInput), {
        disabled: _unref(loading) || _unref(isSubmitted),
        label: "Email",
        name: "email",
        modelValue: _unref(formData).email,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(formData).email) = $event)),
        type: "email"
      }, null, 8, ["disabled", "modelValue"]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_unref(UiSelect), {
          disabled: _unref(loading) || _unref(isSubmitted),
          options: _unref(jobPositionOptions),
          label: "Job title",
          modelValue: _unref(formData).job_position,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(formData).job_position) = $event)),
          name: "job_position"
        }, null, 8, ["disabled", "options", "modelValue"]),
        _createVNode(_unref(UiInput), {
          disabled: _unref(loading) || _unref(isSubmitted),
          label: "Job position",
          modelValue: _unref(formData).business_title,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(formData).business_title) = $event)),
          name: "business_title"
        }, null, 8, ["disabled", "modelValue"]),
        _createVNode(_unref(UiInput), {
          disabled: _unref(loading) || _unref(isSubmitted),
          type: "phone",
          label: "Phone number",
          name: "phone_number",
          modelValue: _unref(formData).phone_number,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(formData).phone_number) = $event))
        }, null, 8, ["disabled", "modelValue"])
      ]),
      _createVNode(_unref(UiLine)),
      _hoisted_11,
      _hoisted_12,
      _createVNode(_unref(UiInput), {
        disabled: _unref(loading) || _unref(isSubmitted),
        modelValue: _unref(formData).description,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(formData).description) = $event)),
        name: "description",
        type: "textarea"
      }, null, 8, ["disabled", "modelValue"]),
      _hoisted_13,
      _createVNode(_unref(UiInput), {
        placeholded: "End users opt-in by visiting www.example.com and adding their phone number. They then check a box agreeing to receive text messages from Example Brand. Additionally, end users can also opt-in by texting START to (111) 222-3333 to opt in. Term and Conditions at www.example.com/tc. Privacy Policy at www.example.com/privacy",
        disabled: _unref(loading) || _unref(isSubmitted),
        modelValue: _unref(formData).message_flow,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(formData).message_flow) = $event)),
        name: "message_flow",
        type: "textarea"
      }, null, 8, ["disabled", "modelValue"]),
      _createVNode(_unref(UiCheckbox), {
        disabled: _unref(loading) || _unref(isSubmitted),
        label: "Has embedded links",
        name: "has_embedded_links",
        modelValue: _unref(formData).has_embedded_links,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(formData).has_embedded_links) = $event))
      }, null, 8, ["disabled", "modelValue"]),
      _createVNode(_unref(UiCheckbox), {
        disabled: _unref(loading) || _unref(isSubmitted),
        label: "Has embedded phone",
        name: "has_embedded_phone",
        modelValue: _unref(formData).has_embedded_phone,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(formData).has_embedded_phone) = $event))
      }, null, 8, ["disabled", "modelValue"]),
      _hoisted_14,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formData).message_samples, (sample, i) => {
        return (_openBlock(), _createBlock(MessageSample, {
          index: i,
          disabled: _unref(loading) || _unref(isSubmitted),
          key: sample.id,
          sample: sample,
          canDelete: _unref(formData).message_samples.length > 2,
          onRemoveItem: ($event: any) => (removeItem(sample.id)),
          modelValue: sample.value,
          "onUpdate:modelValue": ($event: any) => ((sample.value) = $event)
        }, null, 8, ["index", "disabled", "sample", "canDelete", "onRemoveItem", "modelValue", "onUpdate:modelValue"]))
      }), 128)),
      (!_unref(isSubmitted))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_unref(formData).message_samples.length < 5)
              ? (_openBlock(), _createBlock(_unref(UiButton), {
                  key: 0,
                  disabled: _unref(loading) || _unref(isSubmitted),
                  type: "button",
                  theme: "primary-outlined",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (
					_unref(formData).message_samples.push({
						value: '',
						id: randomId()
					})
				))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SvgIcon), {
                      class: "mr-2",
                      name: "only-plus"
                    }),
                    _createTextVNode(" Add message sample ")
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_16,
      (!_unref(isSubmitted))
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_unref(UiButton), { loading: _unref(loading) }, {
              default: _withCtx(() => [
                _createTextVNode(" Submit ")
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}
}

})